import React from 'react';
import AutoExpandTextarea from 'react-textarea-autosize';

import type { Props as AsInputProps } from '@rover/react-lib/src/components/utils/AsInput';
import AsInput from '@rover/react-lib/src/components/utils/AsInput';
import type { Props as LabelAndErrorFormGroupProps } from '@rover/react-lib/src/components/utils/LabelAndErrorFormGroup';
import LabelAndErrorFormGroup from '@rover/react-lib/src/components/utils/LabelAndErrorFormGroup';

const handleKeyPress = (e, onKeyPress) => {
  if (e.key === 'Enter') {
    e.stopPropagation();
  }
  if (onKeyPress) {
    onKeyPress(e);
  }
};

export type Props = Omit<AsInputProps, 'children'> & {
  onKeyPress?: (arg0: Event) => void;
  autoExpand?: boolean;
  value?: string;
  rows?: number;
  disabled?: boolean;
  maxLength?: number;
  validationType: 'popover' | 'inline';
};

const Textarea = ({
  inputRef,
  onChange,
  sensitive,
  className,
  onKeyPress,
  autoExpand,
  ...props
}: Props): JSX.Element => (
  <AsInput
    {...{
      inputRef,
      onChange,
      sensitive,
      className,
    }}
  >
    {(inputProps) => {
      const allProps = {
        ...props,
        ...inputProps,
        onKeyPress: (e) => handleKeyPress(e, onKeyPress),
      };
      return autoExpand ? <AutoExpandTextarea {...allProps} /> : <textarea {...allProps} />;
    }}
  </AsInput>
);

export default (
  props: LabelAndErrorFormGroupProps & Props & { validationType: 'popover' | 'inline' }
): JSX.Element => (
  <LabelAndErrorFormGroup {...props}>
    {/*  we need to explicitly rename ref back to inputRef here so AsInput can pass it to the actual component  */}
    {({ ref, ...rest }) => <Textarea {...rest} inputRef={ref} />}
  </LabelAndErrorFormGroup>
);
export { Textarea as UnwrappedTextarea };
